import { useState, useEffect } from 'react';
import { ListConductor } from '../list-conductor/list-conductor';
import { FilterButton } from './FilterButton/FilterButton';
import { FiltersPopper } from './FiltersPopper/FiltersPopper';
import { getCumulativeFilterCount } from './helpers';
import { Filter } from './interface';
import { AppliedFiltersChips } from './AppliedFiltersChips/AppliedFiltersChips';

export function Filters({
  listConductor,
  filters,
  entity,
  compactControls = false
}: {
  listConductor: ListConductor;
  filters: Filter[];
  entity: string;

  compactControls?: boolean;
}) {
  const [showFilters, setShowFilters] = useState(false);
  const [allFiltersCount, setAllFiltersCount] = useState<number>(0);

  useEffect(() => {
    const appliedFilters = listConductor.getListMeta().filters.filter(filter => {
      return filters.findIndex(filterMeta => filterMeta.filterKey === filter.filter) > -1;
    });
    setAllFiltersCount(getCumulativeFilterCount(appliedFilters));
  }, [listConductor.getListMeta()]);

  return (
    <div className='center-flex-row flex-grow-1 ml-2'>
      <FilterButton
        id={`${entity}-filters`}
        onClick={() => setShowFilters(prev => !prev)}
        filterCount={allFiltersCount}
        iconOnly={compactControls}
      />
      {listConductor.getListMeta().filters.length && !compactControls ? (
        <AppliedFiltersChips
          listConductor={listConductor}
          filtersMetaData={filters}
          entity={entity}
        />
      ) : null}

      <FiltersPopper
        entity={entity}
        target={`#${entity}-filters`}
        open={showFilters}
        filters={filters}
        listConductor={listConductor}
        onClose={() => {
          setShowFilters(false);
        }}
      />
    </div>
  );
}
